/**
 * Cache duration constants for TanStack Query
 */

/** 24 hours in milliseconds - used for Dashboard and Analytics data caching */
export const CACHE_24_HOURS = 24 * 60 * 60 * 1000; // 86,400,000 ms
